import React, { HTMLAttributes } from "react";
import classNames from "classnames";

import { BreadcrumbItem as StyledBreadcrumbItem } from "./Breadcrumb.styled";

type BreadcrumbItemProps = HTMLAttributes<HTMLLIElement>;

const BreadcrumbItem = React.forwardRef<HTMLLIElement, BreadcrumbItemProps>((props, ref) => {
  const { className, ...restProps } = props;
  const breadcrumbItemClass = classNames("c-breadcrumb__item", className);

  return (
    <StyledBreadcrumbItem data-testid="qa-breadcrumb-item" ref={ref} className={breadcrumbItemClass} {...restProps} />
  );
});

export default BreadcrumbItem;
